export const STYLES = {
  INDEX: {
    PROMOTIONS: {
      PROFILE: {
        LAYOUT: 'flex bg-action01 border-b-[2px] border-action05 pt-[6px] pb-[6px] w-[100%] justify-start items-center',
        AS_BUTTON_LAYOUT:
          'mx-auto max-h-[54px] w-[200px] px-[40px] py-[17px] font-metricR text-[16px] leading-[16px] text-bw00 mt-[30px] rounded-[4px] bg-action03 hover:bg-action04 active:bg-action04 outline-none',
        TEXTS_CONTAINER: 'flex-col justify-start pl-[16px] grow',
        TITLE: 'font-metricR text-[14px] text-action05 text-left',
        SUBTITLE: 'font-metricRBoldItalic  text-[16px] text-action05  text-left',
        ARROW: 'w-[16px] h-[16px] stroke-action05 mx-[16px]',
      },
    },
    PLAN_PICKER: {
      TABS: 'flex items-center gap-[8px]',
      SELECTED_TAB: 'h-[26px] text-[12px] bg-action05 text-bw00 hover:bg-action05 w-[77px]',
      UNSELECTED_TAB: 'h-[26px] text-[12px] w-[77px]',
      PLAN: {
        LAYOUT: 'flex flex-col grow border-2 border-action05 rounded-md  shadow-lg',
        MOST_POPULAR: 'font-metricSemibold text-[16px] flex items-center justify-center  text-bw00 mt-[2px]',
        INFO: 'w-[422px]  flex-col flex h-full  items-center',
        CONTENT: 'flex items-center grow   justify-between ',
        DIVIDER: 'w-[1px]  bg-bw05 h-[95%]',
        HIGHLIGHTS: 'grow  flex-col h-full flex relative ',
        HIGHLIGHTS_CONTENT: 'absolute inset-0 overflow-auto max-h-full  flex flex-col justify-start  ml-[30px]',
        HIGHLIGHT_SECTION_TITLE: 'font-metricRSemibold font-[16px]  text-bw08',
        HIGHLIGHT_ROW_TITLE: 'font-metricRSemibold font-[14px] text-bw08 pr-[8px] pl-[4px]',
        HIGHLIGHT_ROW_DESCRIPTION: 'font-metricR font-[14px] text-bw08',
        HIGHLIGHT_ROW_NEW_BADGE:
          'font-metric text-[12px] text-center text-bw00 bg-action05 py-[3px] px-[12px] rounded mr-[6px] bg-action05',
        CHECKMARK: 'mt-[5px] stroke-bw08',
        PRICE: 'font-metricRMedium text-[36px]',
        MONTH: 'font-metricRMedium text-[28px]',
        BUTTON: 'w-[254px] h-[64px] max-w-[254px] whitespace-nowrap',
        DISCLAIMER: 'font-metric text-[10px] text-bw06 mt-[16px]',
      },
      CONFIRMATION: {
        LAYOUT: 'flex flex-col w-[456px] h-[342px] bg-bw00 rounded-lg    pt-[44px] pb-[50px] animate-fadeIn px-[50px]',
        TITLE: 'font-metricRSemibold text-bw08 text-[22px] text-left',
        DESCRIPTION: 'font-metricRMedium text-bw07 text-[18px] mt-[6px]',
        BUTTON: 'mt-[37px] w-full whitespace-nowrap ',
        TERMS_OF_USE_CONTAINER: 'flex  items-start gap-[2px]  mt-[27px] ',
        TERMS_OF_USE: 'font-metricR text-bw07',
        TERMS_OF_USE_LINK: 'font-metricR text-action03 underline',
        CHECKBOX: 'hover:cursor-pointer w-[14px] min-w-[14px] h-[14px] mr-[8px] mt-[4px] checked:accent-action03 ',
      },
      SUCCESS: {
        LAYOUT:
          'flex flex-col w-[456px] h-[444px] bg-bw00 rounded-lg items-center justify-between  pt-[60px] pb-[50px] px-[25px] animate-fadeIn',
        TITLE: 'font-metricRSemibold text-[22px] mb-[15px]',
        SUBTITLE: 'font-metricR text-[16px] text-bw07 text-center',
        DISCLAIMER: 'font-metricR text-[14px] text-bw07 text-center',
      },
    },
  },
};
export const TEXT = {
  PROFILE: {
    TYPES: {
      BASIC: {
        TITLE: 'PLAN_UPGRADE.PROFILE_PROMOTION.PROFILE_PROMOTION_BASIC_TITLE',
        SUBTITLE: 'PLAN_UPGRADE.PROFILE_PROMOTION.PROFILE_PROMOTION_BASIC_SUBTITLE',
      },
      PRO: {
        TITLE: 'PLAN_UPGRADE.PROFILE_PROMOTION.PROFILE_PROMOTION_PRO_TITLE',
        SUBTITLE: 'PLAN_UPGRADE.PROFILE_PROMOTION.PROFILE_PROMOTION_PRO_SUBTITLE',
      },
      SMART: {
        TITLE: 'PLAN_UPGRADE.PROFILE_PROMOTION.PROFILE_PROMOTION_SMART_TITLE',
        SUBTITLE: 'PLAN_UPGRADE.PROFILE_PROMOTION.PROFILE_PROMOTION_SMART_SUBTITLE',
      },
    },
  },
  PLAN_PICKER: {
    TITLE: 'PLAN_UPGRADE.PLAN_PICKER.TITLE',
    UPGRADE_BUTTON: 'PLAN_UPGRADE.PLAN_PICKER.UPGRADE_BUTTON',
    ACCEPT_BUTTON: 'PLAN_UPGRADE.PLAN_PICKER.ACCEPT_BUTTON',
    SUCCESS_BUTTON: 'PLAN_UPGRADE.PLAN_PICKER.SUCCESS_BUTTON',
    HIGHLIGHTS: 'PLAN_UPGRADE.PLAN_PICKER.HIGHLIGHTS_TITLE',
    MOST_POPULAR: 'PLAN_UPGRADE.PLAN_PICKER.MOST_POPULAR',
    CONFIRMATION_TITLE: 'PLAN_UPGRADE.PLAN_PICKER.CONFIRMATION_TITLE',
    CONFIRMATION_SUBTITLE: 'PLAN_UPGRADE.PLAN_PICKER.CONFIRMATION_SUBTITLE',
    CONFIRMATION_BUTTON: 'PLAN_UPGRADE.PLAN_PICKER.CONFIRMATION_BUTTON',
    SUCCESS_TITLE: 'PLAN_UPGRADE.PLAN_PICKER.SUCCESS_TITLE',
    SUCCESS_SUBTITLE: 'PLAN_UPGRADE.PLAN_PICKER.SUCCESS_SUBTITLE',
    SUCCESS_DISCLAIMER: 'PLAN_UPGRADE.PLAN_PICKER.SUCCESS_DISCLAIMER',
    PREMIUM_SUCCESS_SUBTITLE: 'PLAN_UPGRADE.PLAN_PICKER.PREMIUM_SUCCESS_SUBTITLE',
    PREMIUM_SUCCESS_DISCLAIMER: 'PLAN_UPGRADE.PLAN_PICKER.PREMIUM_SUCCESS_DISCLAIMER',
    PRICE_PER_MONTH: 'PLAN_UPGRADE.PLAN_PICKER.PRICE_PER_MONTH',
    NEW_BADGE: 'PLAN_UPGRADE.PLAN_PICKER.NEW_BADGE',
  },
} as const;

export enum LiliPlanType {
  BASIC_V2 = 'BASIC_V2',
  BASIC = 'BASIC',
  PRO_V2 = 'PRO_V2',
  PRO = 'PRO',
  SMART = 'SMART',
  PREMIUM = 'PREMIUM',
}
